import React, { useState, useEffect } from "react";
import firebase from "firebase";
import { useHistory } from "react-router";
import Swal from "sweetalert2";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import { Link } from "react-router-dom";
// import { isDesktop, isMobile } from "react-device-detect";
import { CircularProgress, FormControl, Button } from "@material-ui/core";
import { KTCookie } from "../../../../_metronic/_assets/js/components/cookie";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { API_URL } from "../../../../constants";
import {
  onAxiosApiCall,
  useLocalStorage,
  getLanguage,
} from "../../../../utils";
import { KTUtil } from "./../../../../_metronic/_assets/js/components/util.js";

import firebaseConfig from "../../../../firebaseConfig";
import FacebookIcon from "../../../../assets/images/facebook-icon.png";
import GoogleIcon from "../../../../assets/images/google-icon.png";
import styles from "./login.module.scss";

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
} else {
  firebase.app();
}

function Login(props) {
  var language = getLanguage(navigator.language);
  const [localStorageData, setLocalStorageData] = useLocalStorage(
    "clientpanel"
  );
  const history = useHistory();
  const [values, setValues] = useState({
    email: "",
    password: "",
  });
  const [fromPwaApp, setFromPwaApp] = useState(false);
  const [loading, setLoading] = useState(false);
  const [googleBtnLoading, setGoogleBtnLoading] = useState(false);
  const [fbBtnLoading, setFbBtnLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const bgImage = toAbsoluteUrl("/media/bg/bg-3.jpg");
  // client panel content
  const [clientPanelContent, setClientPanelContent] = useState("");

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const pwaAppId = urlParams.get("redirect");
    if (
      document.referrer &&
      pwaAppId !== undefined &&
      pwaAppId !== null &&
      pwaAppId !== ""
    ) {
      localStorage.setItem(
        "previousPwaAppUrl",
        `${document.referrer}${pwaAppId}/home`
      );
      setFromPwaApp(true);
      setTimeout(() => {
        history.push("/login");
      }, 200);
    }
    getClientPanelContent();
  }, []);

  // change
  const handleChange = (event) => {
    let tempValues = { ...values };
    tempValues[event.target.name] =
      event.target.type === "checkbox"
        ? event.target.checked
        : event.target.value;
    setValues(tempValues);
  };

  // get client panel contents
  const getClientPanelContent = () => {
    const section = "login_screen";
    onAxiosApiCall(
      API_URL + language + "/get-client-panel-content/" + section,
      "GET",
      ""
    ).then((response) => {
      if (response.data !== undefined && response.data !== "") {
        setClientPanelContent(response.data[section]);
      } else {
        setClientPanelContent("");
      }
    });
  };

  // social login
  // google
  const handleGoogleLogin = (event) => {
    event.preventDefault();
    setGoogleBtnLoading(true);
    var provider = new firebase.auth.GoogleAuthProvider();
    firebase
      .auth()
      .signInWithPopup(provider)
      .then(async (result) => {
        var user = result.user;
        if (user.uid !== "" && user.email !== "") {
          onAxiosApiCall(API_URL + "social-login", "POST", {
            firebase_id: user.uid,
            email: user.email,
            login_type: "Google",
          })
            .then((response) => {
              if (response.status === 200) {
                let userData = Object.assign({}, response.data);
                setGoogleBtnLoading(false);
                setLocalStorageData(userData);
                var prevPath = KTCookie.getCookie("prevPath");
                if (
                  prevPath !== undefined &&
                  prevPath == "/update-billing-info"
                ) {
                  window.location.replace(prevPath);
                } else {
                  window.location.replace("/my-videos");
                }
                // KTCookie.deleteCookie('prevPath');
              } else {
                setGoogleBtnLoading(false);
                Swal.fire(
                  clientPanelContent[response.error_key] !== undefined
                    ? clientPanelContent[response.error_key]
                    : "",
                  "",
                  "error"
                );
              }
            })
            .catch((error) => {
              console.log("error", error);
              setGoogleBtnLoading(false);
            });
        }
      })
      .catch((error) => {
        console.log("error111", error);
        setGoogleBtnLoading(false);
      });
  };

  // facebook
  const handleFacebookLogin = (event) => {
    event.preventDefault();
    setFbBtnLoading(true);
    var provider = new firebase.auth.FacebookAuthProvider();
    provider.addScope("email");
    firebase
      .auth()
      .signInWithPopup(provider)
      .then(async (result) => {
        var user = result.user;
        if (user.uid !== "" && user.email !== "") {
          onAxiosApiCall(API_URL + "social-login", "POST", {
            firebase_id: user.uid,
            email: user.email,
            login_type: "Facebook",
          })
            .then((response) => {
              if (response.status === 200) {
                let userData = Object.assign({}, response.data);
                setFbBtnLoading(false);
                setLocalStorageData(userData);
                var prevPath = KTCookie.getCookie("prevPath");
                if (
                  prevPath !== undefined &&
                  prevPath == "/update-billing-info"
                ) {
                  window.location.replace(prevPath);
                } else {
                  window.location.replace("/my-videos");
                }
                // KTCookie.deleteCookie('prevPath');
              } else {
                setFbBtnLoading(false);
                Swal.fire(
                  clientPanelContent[response.error_key] !== undefined
                    ? clientPanelContent[response.error_key]
                    : "",
                  "",
                  "error"
                );
              }
            })
            .catch((error) => {
              console.log("error", error);
              setFbBtnLoading(false);
            });
        }
      })
      .catch((error) => {
        console.log("error", error);
        setFbBtnLoading(false);
      });
  };

  // submit
  const handleSubmit = () => {
    setLoading(true);
    setDisabled(true);
    onAxiosApiCall(API_URL + "login", "POST", values)
      .then((response) => {
        if (response.status === 200) {
          let userData = Object.assign({}, response.data);
          userData.language = response.data.pwa_config2.e_language;
          setLoading(false);
          setDisabled(false);
          setLocalStorageData(userData);
          var prevPath = KTCookie.getCookie("prevPath");
          if (prevPath !== undefined && prevPath == "/update-billing-info") {
            window.location.replace(prevPath);
          } else {
            window.location.replace("/my-videos");
          }
          // KTCookie.deleteCookie('prevPath');
        } else {
          setLoading(false);
          setDisabled(false);
          Swal.fire(
            clientPanelContent[response.error_key] !== undefined
              ? clientPanelContent[response.error_key]
              : "",
            "",
            "error"
          );
        }
      })
      .catch((error) => {
        console.log("error", error);
        setLoading(false);
        setDisabled(false);
      });
  };

  const gotToPwaApp = () => {
    const previousPwaAppUrl = localStorage.getItem("previousPwaAppUrl");
    if (
      previousPwaAppUrl !== undefined &&
      previousPwaAppUrl !== null &&
      previousPwaAppUrl !== ""
    ) {
      window.location.assign(previousPwaAppUrl);
    }
  };

  return (
    <div
      className={`login login-3 wizard d-flex flex-column flex-lg-row h-100 w-100 ${
        KTUtil.isMobileDevice() ? "mobile-login" : "flex-column-fluid"
      }`}
    >
      <div
        className={`login-aside flex-column flex-center flex-row-auto ${styles.loginRoot} `}
      >
        <div
          className={`d-flex justify-content-start align-items-center h-100 px-10`}
        >
          <div className={`${styles.leftsideTextDiv}`}>
            <div className="d-flex mb-10">
              <img
                src={toAbsoluteUrl("/media/logos/white-logo.png")}
                className={`w-230px ${styles.desktopLogo}`}
                alt=""
              />
            </div>
            <h2
              className={`font-weight-bolder ${styles.welcomBackText}`}
              dangerouslySetInnerHTML={{
                __html:
                  clientPanelContent !== undefined &&
                  clientPanelContent !== "" &&
                  clientPanelContent.page_title !== undefined &&
                  clientPanelContent.page_title !== ""
                    ? clientPanelContent.page_title
                    : "Welcome Back to <br />Youshow",
              }}
            ></h2>
            <div className={`${styles.separator}`}></div>
            <h4
              className={`font-weight-bolder ${styles.subtext}`}
              dangerouslySetInnerHTML={{
                __html:
                  clientPanelContent !== undefined &&
                  clientPanelContent !== "" &&
                  clientPanelContent.sub_title !== undefined &&
                  clientPanelContent.sub_title !== ""
                    ? clientPanelContent.sub_title
                    : "Sign in to continue to your account.",
              }}
            ></h4>
          </div>
        </div>

        {/* <div className="aside-img d-flex flex-row-fluid bgi-no-repeat bgi-position-x-center" style="background-position-y: calc(100% + 5rem); background-image: url(assets/media/svg/illustrations/login-visual-5.svg)"></div> */}
      </div>

      <div className={`login-content flex-row-fluid d-flex flex-column justify-content-center p-10 `}>
        <div className="d-flex flex-row-fluid flex-center">
          <div className="login-form">
            <div className="d-flex flex-center mb-15">
              <img
                src={toAbsoluteUrl("/media/logos/white-logo.png")}
                className={`w-250px ${styles.mobileLogo}`}
                alt=""
              />
            </div>
            <div className="login-signin">
              {/* <div className="mb-10 text-center">
                <h3>
                  {clientPanelContent !== undefined &&
                  clientPanelContent !== "" &&
                  clientPanelContent.page_title !== undefined &&
                  clientPanelContent.page_title !== ""
                    ? clientPanelContent.page_title
                    : ""}
                </h3>
                <div className="text-muted font-weight-bold">
                  {clientPanelContent !== undefined &&
                  clientPanelContent !== "" &&
                  clientPanelContent.sub_title !== undefined &&
                  clientPanelContent.sub_title !== ""
                    ? clientPanelContent.sub_title
                    : ""}
                </div>
              </div> */}

              <ValidatorForm
                id="kt_login_signin_form"
                onSubmit={handleSubmit}
                className="form-validator"
                onError={(errors) => console.log(errors)}
              >
                {/* <div className="mt-10 mb-5 text-center">
                  <p className="or-text">
                    {clientPanelContent !== undefined &&
                    clientPanelContent !== "" &&
                    clientPanelContent.social_signin_text !== undefined &&
                    clientPanelContent.social_signin_text !== ""
                      ? clientPanelContent.social_signin_text
                      : ""}
                  </p>
                </div> */}

                <div className="socialLogin">
                  <div
                    className={`align-self-left mt-5 mb-5 ${styles.socialIconBtn}`}
                    onClick={handleFacebookLogin}
                    disabled={fbBtnLoading}
                  >
                    <img
                      src={FacebookIcon}
                      alt={
                        clientPanelContent !== undefined &&
                        clientPanelContent !== "" &&
                        clientPanelContent.login_with_fb_btn_text !==
                          undefined &&
                        clientPanelContent.login_with_fb_btn_text !== ""
                          ? clientPanelContent.login_with_fb_btn_text
                          : ""
                      }
                    />
                    {clientPanelContent !== undefined &&
                    clientPanelContent !== "" &&
                    clientPanelContent.login_with_fb_btn_text !== undefined &&
                    clientPanelContent.login_with_fb_btn_text !== ""
                      ? clientPanelContent.login_with_fb_btn_text
                      : ""}
                  </div>

                  <div
                    className={`align-self-left mb-5 ${styles.socialIconBtn}`}
                    onClick={handleGoogleLogin}
                    disabled={googleBtnLoading}
                  >
                    <img
                      src={GoogleIcon}
                      alt={
                        clientPanelContent !== undefined &&
                        clientPanelContent !== "" &&
                        clientPanelContent.login_with_google_btn_text !==
                          undefined &&
                        clientPanelContent.login_with_google_btn_text !== ""
                          ? clientPanelContent.login_with_google_btn_text
                          : ""
                      }
                    />
                    {clientPanelContent !== undefined &&
                    clientPanelContent !== "" &&
                    clientPanelContent.login_with_google_btn_text !==
                      undefined &&
                    clientPanelContent.login_with_google_btn_text !== ""
                      ? clientPanelContent.login_with_google_btn_text
                      : ""}
                  </div>
                </div>

                <div
                  className={`flex-wrap align-items-center mt-7 mb-7 ${
                    styles.loginWithEmailText
                  } ${KTUtil.isMobileDevice() ? "d-none" : ""}`}
                >
                  <span className={`${styles.line}`}></span>
                  <span className={`${styles.text}`}>
                    {clientPanelContent !== undefined &&
                    clientPanelContent !== "" &&
                    clientPanelContent.social_signin_text !== undefined &&
                    clientPanelContent.social_signin_text !== ""
                      ? clientPanelContent.social_signin_text
                      : ""}
                  </span>
                  <span className={`${styles.line}`}></span>
                </div>

                <div className="form-group mb-2">
                  <FormControl className={`${styles.formControl} width-100`}>
                    {/* <FormLabel component="legend" className="legend">
                      {clientPanelContent !== undefined &&
                      clientPanelContent !== "" &&
                      clientPanelContent.email_txt !== undefined &&
                      clientPanelContent.email_txt !== ""
                        ? clientPanelContent.email_txt
                        : ""}
                    </FormLabel> */}
                    <TextValidator
                      type="email"
                      fullWidth
                      name="email"
                      placeholder={
                        clientPanelContent !== undefined &&
                        clientPanelContent !== "" &&
                        clientPanelContent.email_txt !== undefined &&
                        clientPanelContent.email_txt !== ""
                          ? clientPanelContent.email_txt
                          : ""
                      }
                      onChange={handleChange}
                      value={values.email}
                      variant="outlined"
                      autoComplete="off"
                      InputProps={{ classes: { input: "textField" } }}
                      validators={["required", "isEmail"]}
                      errorMessages={[
                        clientPanelContent.email_required_txt
                          ? clientPanelContent.email_required_txt
                          : "This field is required",
                        clientPanelContent.wrong_email_txt
                          ? clientPanelContent.wrong_email_txt
                          : "Email address is not valid",
                      ]}
                    />
                  </FormControl>
                  <FormControl
                    className={`${styles.formControl} width-100 mt-5`}
                  >
                    {/* <FormLabel component="legend" className="legend">
                      {clientPanelContent !== undefined &&
                      clientPanelContent !== "" &&
                      clientPanelContent.password_txt !== undefined &&
                      clientPanelContent.password_txt !== ""
                        ? clientPanelContent.password_txt
                        : ""}
                    </FormLabel> */}
                    <TextValidator
                      type="password"
                      fullWidth
                      name="password"
                      placeholder={
                        clientPanelContent !== undefined &&
                        clientPanelContent !== "" &&
                        clientPanelContent.password_txt !== undefined &&
                        clientPanelContent.password_txt !== ""
                          ? clientPanelContent.password_txt
                          : ""
                      }
                      onChange={handleChange}
                      value={values.password}
                      variant="outlined"
                      autoComplete="off"
                      InputProps={{ classes: { input: "textField" } }}
                      validators={["required"]}
                      errorMessages={
                        clientPanelContent.password_requird_error
                          ? clientPanelContent.password_requird_error
                          : ["This field is required"]
                      }
                    />
                  </FormControl>
                </div>

                <div className="d-flex flex-wrap justify-content-end align-items-center mb-4">
                  <Link
                    to="forgot-password"
                    className={`${styles.fogotPassText}`}
                  >
                    {clientPanelContent !== undefined &&
                    clientPanelContent !== "" &&
                    clientPanelContent.forgot_password_txt !== undefined &&
                    clientPanelContent.forgot_password_txt !== ""
                      ? clientPanelContent.forgot_password_txt
                      : ""}
                  </Link>
                </div>

                <div className="col-md-12 mt-5 mt-5 px-0">
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    className={styles.submitBtn}
                    disabled={disabled}
                  >
                    {clientPanelContent !== undefined &&
                    clientPanelContent !== "" &&
                    clientPanelContent.sign_in_btn_text !== undefined &&
                    clientPanelContent.sign_in_btn_text !== ""
                      ? clientPanelContent.sign_in_btn_text
                      : ""}
                    {loading && (
                      <CircularProgress
                        size="1.5rem"
                        style={{color: '#fff'}}
                        className="ml-2"
                      />
                    )}
                  </Button>
                </div>

                {/* <button
                  type="submit"
                  className={`d-flex justify-content-center align-items-center btn btn-primary green-button-without-hover font-weight-bold w-100`}
                  disabled={disabled}
                >
                  {clientPanelContent !== undefined &&
                  clientPanelContent !== "" &&
                  clientPanelContent.sign_in_btn_text !== undefined &&
                  clientPanelContent.sign_in_btn_text !== ""
                    ? clientPanelContent.sign_in_btn_text
                    : ""}
                  {loading && (
                    <CircularProgress size="1.5rem" color="#fff" className="ml-2" />
                  )}
                </button> */}

                <div className={`${styles.notYetMemberLink}`}>
                  {clientPanelContent !== undefined &&
                  clientPanelContent !== "" &&
                  clientPanelContent.not_yet_member_text !== undefined &&
                  clientPanelContent.not_yet_member_text !== ""
                    ? clientPanelContent.not_yet_member_text
                    : "Not a member yet?"}
                  &nbsp;
                  <a href="https://www.youshow.org/#pricing">
                    {clientPanelContent !== undefined &&
                    clientPanelContent !== "" &&
                    clientPanelContent.signup_text !== undefined &&
                    clientPanelContent.signup_text !== ""
                      ? clientPanelContent.signup_text
                      : "Sign Up"}
                  </a>
                </div>

                {fromPwaApp && (
                  <a
                    href="#"
                    className={`d-flex flex-wrap justify-content-center align-items-center go-to-app ${styles.backtoLogin}`}
                    onClick={gotToPwaApp}
                  >
                    <svg
                      width="10"
                      height="12"
                      viewBox="0 0 6 8"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5.28027 0.94L2.22027 4L5.28027 7.06L4.33361 8L0.333607 4L4.33361 -4.13801e-08L5.28027 0.94Z"
                        fill="#FF6D3F"
                      />
                    </svg>{" "}
                    {clientPanelContent !== undefined &&
                    clientPanelContent !== "" &&
                    clientPanelContent.go_to_app_btn_text !== undefined &&
                    clientPanelContent.go_to_app_btn_text !== ""
                      ? clientPanelContent.go_to_app_btn_text
                      : ""}
                  </a>
                )}
              </ValidatorForm>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
